export const prefixByChannel = {
  'ru': 'ru'
};

export const channelByPrefix = Object.entries(prefixByChannel).reduce((acc, [key, val]) => {
  acc[val] = key;
  return acc;
}, {});

export function isIndexRoute(path) {
  const [, maybePrefix, pathPart] = path.split('/', 3);

  if (!maybePrefix) {
    return true;
  }

  const maybeChannelByPrefix = channelByPrefix[maybePrefix];

  return maybeChannelByPrefix && !pathPart;
}



// WEBPACK FOOTER //
// ./routes/prefixes.js